<template>
	<!-- <v-dialog
		v-model="dialog_dev"
		width="800"
	> -->
		<v-card outlined 
			style = " 
				width 		: 100%; 
				height 		: 100%; 
				object-fit 	: fill;
				" 
			class = "pb-0 vue-draggable-handle white--text"
			:ref   = "'card_device' + layout_id"
		>
			<v-card-title
				class = "pa-0 caption secondary"
				
			>
			<v-icon
				x-small
				color  = "primary"
				class  = "px-2"
				v-text = "'mdi-video'"
			></v-icon>
			<span 
				v-text = "$ml.get('device')"
			></span>
			<v-spacer></v-spacer>
			<!-- <v-btn
					x-small
					color="error"
				>
					<v-icon
						x-small
						color="white"
						v-text="'mdi-close'"
					></v-icon>
				</v-btn> -->
			</v-card-title>
			<v-card-text
				class = "pb-0 pa-1"
			>
				<v-tabs
			      dark
			      fixed-tabs
			      v-model 			= "tab"
			      background-color  = "primary"
			      height  			= "20"
			    >
			      <v-tab
			        v-for = "(item_tab, idx_tab) of info_tabs"
			        :key  = "idx_tab"
			      >
			        {{ item_tab.text }}
			      </v-tab>
			    </v-tabs>

			    <v-tabs-items v-model = "tab">
				    <v-tab-item
				        v-for = "(item_tab_i, idx_tab_i) of info_tabs"
				        :key  = "idx_tab_i"
				    >
							<!-- v-show = "idx_tab_i === 0" -->
							<!-- v-show 				= "idx_tab_i == 0" -->
						<!-- <input_fields
							key 				= "fields_device"
						></input_fields> -->
						<component 
							:key 				= "item_tab_i.key"
							:input_info 		= "info_fields"
							:action_info 		= "action_to_field.action"
							:set_info 			= "action_to_field.info"						
							@recive_info_field 	= "receive_info($event, 'field')"
							:is_edit  			= "true"							
							:is 				= "item_tab_i.component"
							:style 				= "`height: ${height_map}px`"
							:edit  				= "true"	
							:info_to_component 	= "{ locations : location}"
							@recive_location   	= "actions('location', $event)"
							:setting_to_map 	= "{ 
											hide_bar   	 : true,
											gps_inactive : true,
										}"
						></component>
							<!-- v-show 				= "idx_tab_i == 1" -->
						<!-- <mapview
						></mapview> -->

					</v-tab-item>
				</v-tabs-items>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
					<v-btn
						x-small
						color  = "primary"
						v-text = "$ml.get('update')"
						@click = "actions('update')"
						v-show = "!loading" 
					></v-btn>
					<template 
						v-for  = "(item_field, idx_field) of list_btns"
					>
						<!-- v-show = "" -->
						
					
						<v-btn
							x-small
							
							:color 	= "item_field.color"
							@click 	= "actions(item_field.action, item_field)"
							v-show  = "!loading && item_field.show"
						>
						
							<v-icon
								x-small
								v-if 	= "item_field.icon"						
								:color 	= "item_field.icon_color"
								class 	= "mr-1"
							>
								{{ item_field.icon }}
							</v-icon>
							<span
								v-show = "item_field.text"
							>
								{{ item_field.text}}	
							</span>
							
						</v-btn>				
					</template>
					<v-progress-linear
						color  = "primary"
						v-show = "loading" 
						indeterminate
					></v-progress-linear>
				<v-spacer></v-spacer>

			</v-card-actions>
		</v-card>
	<!-- </v-dialog> -->
</template>
<script>
	import input_fields from '@/components/info/input_fields.vue'
	import axios 		from 'axios'
	import Eventbus 	from '@/event-bus'
	import mapview 		from '@/components/mapview.vue'

	export default{
		name: 'device',
		components:{
			input_fields,
			mapview,
		}, // components
		props: [
			'info_to_device',
			'is_open_device',
			'layout_id',
		], // props
		data: (vm) => ({
			inf 			: {},
			action_to_field : {

				action 	: '',
				info 	: {}
			},
			info_fields: [
					{
						key: 'rtsp',
						text: 'channel',
						tooltip: 'tooltip_rtsp',
						text1: '1',
						type: 'check',
						icon: 'mdi-video',						
						icon_record : 'mdi-record-rec',
						icon_retransmission : 'mdi-video-wireless',						
						show : true,
						show_in : ["IP_CAM"],
						cols: {

							xl: '12',
							lg: '12',
							md: '12',
							xs: '12',
							cols: '12',
						}
					},
					{
						key: 'rtsp2',
						text: 'channel',
						tooltip: 'tooltip_rtsp2',
						text1 : '2',
						type: 'check',
						icon: 'mdi-video',						
						icon_record : 'mdi-record-rec',
						icon_retransmission : 'mdi-video-wireless',						
						show : true,
						show_in : ["IP_CAM"],

						cols: {

							xl: '12',
							lg: '12',
							md: '12',
							xs: '12',
							cols: '12',
						}
					},
					/*{
						key: 'hls',
						text: 'stream_hls',
						text1 : '2',
						type: 'text',
						icon: 'mdi-video',						
						icon_record : 'mdi-record-rec',
						icon_retransmission : 'mdi-video-wireless',						
						show : true,
						show_in : ["IP_CAM"],

						cols: {

							xl: '12',
							lg: '12',
							md: '12',
							xs: '12',
							cols: '12',
						}
					},*/
					{
						//'name device',						
						key: 'name',
						text: 'name',
						tooltip: 'tooltip_name',
						type: 'text',
						icon: "mdi-map-marker",
						rules : [
							
								value => value && value.length >= 4 || 'Min 4 characters'
													
						],
						counter_active : true,
						show : true,
						cols: {

							xl: '6',
							lg: '6',
							md: '6',
							xs: '12',
							cols: '12',
						}
					},
					{
						key: 'deviceId',
						text: 'uuid',
						tooltip: 'tooltip_uuid',
						type: 'text',
						icon: 'mdi-video',
						is_read : true,
						show : true,
						cols: {

							xl: '6',
							lg: '6',
							md: '6',
							xs: '12',
							cols: '12',
						}
					},
					/*{

						key: 'user',
						text:'user',
						type: 'text',
						value : 'admin',						
						icon: 'mdi-account',
						show : true,
						show_in : ["IP_CAM"],
						cols: {

							xl: '6',
							lg: '6',
							md: '6',
							xs: '12',
							cols: '12',
						}
					},

					{
						key: 'password',
						text: 'password',
						type: 'password',
						icon: 'mdi-lock',
						value : '1234',
						show : true,
						show_in : ["IP_CAM"],
						cols: {

							xl: '6',
							lg: '6',
							md: '6',
							xs: '12',
							cols: '12',
						}
					},*/
					{
						key: 'is_record',
						text:'record',
						tooltip: 'tooltip_record',
						type: 'switch',
						icon: 'mdi-record-rec',
						show : true,
						show_in : ["IP_CAM"],
						cols: {

							xl: '6',
							lg: '6',
							md: '6',
							xs: '12',
							cols: '12',
						}
					},
					{
						key: 'limit',
						text:'limit',
						tooltip: 'tooltip_limit',
						type: 'capacity',
						icon: 'mdi-file-video',
						placeholder : 'MB/GB',
						show : true,
						show_in : ["IP_CAM"],
						cols: {

							xl: '6',
							lg: '6',
							md: '6',
							xs: '12',
							cols: '12',
						}
					},
					{
						key: 'ip_machine',
						text: 'ip_machine',
						type: 'text',
						icon: 'mdi-ip',
						value : '127.0.0.1',						
						show : false,
						show_in : ["IP_CAM"],
						cols: {

							xl: '6',
							lg: '6',
							md: '6',
							xs: '12',
							cols: '12',
						}
					},
					{
						key 	: 'image',
						text 	: 'image',
						type 	: 'select',
						items 	: [
							'jcaltamare/ebenezermotion:latest', 
							'jcaltamare/ebenezermotion:motion_no_avx',
							'jcaltamare/ebenezermotion:motion_arm_ubuntu_20' , 
						],						
						icon 	: 'mdi-docker',
						value 	: '127.0.0.1',						
						show 	: false,
						show_in : ["IP_CAM"],
						cols 	: {

							xl: '6',
							lg: '6',
							md: '6',
							xs: '12',
							cols: '12',
						}
					},
					{
						key: 'video_for_display',
						text:'streaming',
						tooltip: 'tooltip_streaming',
						type: 'switch',
						icon: 'mdi-video',
						placeholder : '',
						show : true,
						show_in : ["IP_CAM"],
						cols: {

							xl: '6',
							lg: '6',
							md: '6',
							xs: '12',
							cols: '12',
						}
					},
					{
						key: 'optimize_tracker',
						text:'optimize_tracker',
						tooltip: 'tooltip_optimize_tracker',
						type: 'switch',
						icon: 'mdi-image',
						placeholder : '',
						show : true,
						show_in : ["IP_CAM"],
						cols: {

							xl: '6',
							lg: '6',
							md: '6',
							xs: '12',
							cols: '12',
						}
					},
					
					
					{
						key 		: 'type_peripheral',
						text 		: 'type_peripheral',
						tooltip: 'tooltip_type_peripheral',
						placeholder : 'Type Peripheral',
						text1 		: '1',
						type 		: 'select',
						items 		: ['siren','electronic_lock', 'arduino', 'iot_relay', 'odroid'],
						icon 		: 'mdi-diving-scuba',
						show 		: false,
						show_in 	: ["PERIPHERAL"],
						cols 		: {

							xl 		: '6',
							lg 		: '6',
							md 		: '6',
							xs 		: '12',
							cols 	: '12',
						}
					},
					{
						key 		: 'arduino',
						text 		: 'arduino',
						tooltip: 'tooltip_arduino',
						placeholder : 'arduino',
						text1 		: '',
						type 		: 'select',
						key_list    : "list_arduinos",
						items 		: [],
						icon 		: 'mdi-form-select',
						show 		: false,
						return_obj  : true,
						item_text 	: "path",
						show_in 	: ["PERIPHERAL"],						
						item_value  : "",
						clearable  	: true,
						cols 		: {
							xl 		: '6',
							lg 		: '6',
							md 		: '6',
							xs 		: '12',
							cols 	: '12',
						}
					},					
					{
						key: 'mode',
						text:'mode',
						tooltip: 'tooltip_mode',
						type: 'select',
						icon 	: "mdi-circle-double",
						items 		: ['in','out'],						
						value : '0',
						show : true,
						show_in 	: ["PERIPHERAL"],						
						cols: {
							xl 		: '6',
							lg 		: '6',
							md 		: '6',
							xs 		: '12',
							cols 	: '12',
						}
					},
					{
						key: 'medium',
						text:'medium',
						tooltip: 'tooltip_medium',
						type: 'select',
						items:['USB','TCP', 'GPIO', 'HTTP'],
						icon  : "mdi-connection",
						value : '0',
						show : false,
						show_in 	: ["PERIPHERAL"],
						cols: {

							xl 		: '6',
							lg 		: '6',
							md 		: '6',
							xs 		: '12',
							cols 	: '12',
						}
					},

					{
						key 	: 'pin',
						text 	: 'pin',
						tooltip: 'tooltip_pin',
						type 	: 'numberr',
						icon 	: "mdi-chip", 
						value 	: '0',
						show  	: false,
						// show_in 	: ["PERIPHERAL"],
						cols 	: {

							xl 		: '6',
							lg 		: '6',
							md 		: '6',
							xs 		: '12',
							cols 	: '12',
						}
					},
					{
						key: 'ip',
						text:'ip',
						tooltip: 'tooltip_ip',
						type: 'text',
						icon 	: "mdi-ip-outline",
						value : '0',
						show : false,
						show_in 	: ["PERIPHERAL"],
						cols: {

							xl 		: '6',
							lg 		: '6',
							md 		: '6',
							xs 		: '12',
							cols 	: '12',
						}
					},
					{
						key: 'serial',
						text:'serial',
						tooltip: 'tooltip_serial',
						type: 'text',
						icon 	: "mdi-serial-port",
						value : '0',
						show : false,
						show_in 	: ["PERIPHERAL"],
						cols: {

							xl 		: '6',
							lg 		: '6',
							md 		: '6',
							xs 		: '12',
							cols 	: '12',
						}
					},
					{
						key: 'type',
						text:'type',
						tooltip: 'tooltip_type',
						type: 'select',
						icon: 'mdi-format-list-bulleted-type',
						items 		: ['IP_CAM','PERIPHERAL'],						
						placeholder : '',
						show : true,
						is_read : true,						
						cols: {

							xl: '12',
							lg: '12',
							md: '12',
							xs: '12',
							cols: '12',
						}
					}
					// {key: 'btn',
					// 	text: 'save',
					// 	type: 'btn',
					// 	size: 'small',
					// 	icon: 'mdi-content-save',
					// 	icon_size: 'small',
					// 	icon_color: 'success',

					// 	cols:
					// 		{ 
					// 			xl: 1, 
					// 			lg: 1,
					// 			md: 1,
					// 			xs: 2,
					// 			cols: 2,
					// 			offset: 9
					// 		}	
					// },

				],
			dialog_dev  : false,
			loading 	: false,
			tab 		: null, 
			info_tabs 	: [
				{
					key  : 'info',
					text : 'info',
					component : "input_fields"
				},
				{
					key  : 'map',
					text : 'map',
					component : "mapview",

				}
			], 
			height_map  : 300,			
			location 	: null,
			list_builder : [
				'id',
				'rtsp',
				'rtsp2',
				'name',
				'deviceId',
				'user',
				'password',
				'is_record',
				'limit',
				'capacity',
				'channel_record',
				'channel_retransmission',
				'video_for_display',
				'type',
				'mode',
				'serial',
				'medium',
				'hls',
				'arduino',
				'ip_machine',
				'image',
				'optimize_tracker',
				
				
			],

			list_btns : [
				{
					key 		: 'test_peripheral',
					text 		: vm.$ml.get('test_peripheral'),
					placeholder : '',
					text1 		: '1',
					type 		: 'btn',
					icon_color  : "",
					route 		: "/api/v1/test_peripheral",
					action 		: "test_peripheral",
					color 		: "secondary",
					icon 		: 'mdi-clipboard-search',
					show 		: false,
					show_in 	: ["PERIPHERAL"],
					cols 		: {

						xl 		: '6',
						lg 		: '6',
						md 		: '6',
						xs 		: '12',
						cols 	: '12',
					}
				},
			],
		}), // data

		created(){

			if (this.info_to_device) {
				// console.log("****************************** info device")
				this.render_info(this.info_to_device);
			}

		}, // created

		watch: {
			is_open_device: function(val){
				if (val){
					this.dialog_dev = true;
					// this.render_info(val);
				}
			}, // device

			dialog_dev: function(val){
				if (!val) {

					this.$emit('close_device', false);
				}
			}, // dialog dev

			info_to_device: function(val){
				if (val) {
					this.render_info(val)
				}
			}, // info to device
		}, // watch

		methods:{
			receive_info(val, from){
				if (val.action == 'save' && val?.value) {
					console.log('step 4, recive');
					this.inf.info = val.value;
					// this.save();
				}
				if (val.action == 'update' && val?.value) {
					console.log('step 4, recive update');
					this.inf.info = val.value;
					this.update();
				}
			}, // recive_info

			actions(act, item, opt){
				if (act == 'update' ) {
					console.log('step 1');
					this.action_to_field.action = act;					
				}
				if (act == 'location') {
					if (this.inf && this.inf.info) {						
						this.inf.info.longitude = item.longitude;
						this.inf.info.latitude = item.latitude;
					}else{
						console.log("Not found propertys for info location");
						this.location = {
							longitude : item.longitude,
							latitude  : item.latitude
						} 
					}
				}
				else if (act == "test_peripheral"){
					console.log("TEST new_peripheral : ", item);
					this.test_peripheral(item);
				}
			},

			render_info(item){
				// console.log('Render info device **************', item);
				this.action_to_field.info = item;

				if (item.latitude && item.longitude) {

					this.location =  {
						longitude : item.longitude,
						latitude  : item.latitude
					};
				}
				
				if (item && item.type) {

					if (item.type == 'PERIPHERAL') {
						let idx = this.list_btns.findIndex(x => (x && x.key == 'test_peripheral'))
						if (idx >= 0) {
							this.list_btns[idx].show = true;
						}
					}
				}
			}, // render_info

			update(){

				if (!this.$store.getters["auth/permission"]( this.$route.name || "setting_device", "can_edit", "device")) {
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get("setting_device"),
					})
					this.action_to_field.action = '1';
					return null;
				}
				
				let temp 	= this.inf.info;
				let info_up = this.$Helper.format_req(temp, this.list_builder);
				console.log("info_up ", info_up )
				
				if (info_up && info_up.arduino && info_up.arduino.length > 100 ) {
					info_up.arduino = "";
				}
				if (temp.capacity && temp.limit) {
					info_up.limit = this.$Helper.convert_capacity(temp.capacity, temp.limit, 'string');

				}
				if (info_up.rtsp && info_up.rtsp.indexOf(" ") > -1) {
					info_up.rtsp = info_up.rtsp.split(' ').join('');	
					this.inf.info.rtsp = info_up.rtsp;
				}
				if (info_up.rtsp2 && info_up.rtsp2.indexOf(" ") > -1) {					
					info_up.rtsp2 = info_up.rtsp2.split(' ').join('');
					this.inf.info.rtsp2 = info_up.rtsp2;
				}
				
				const api = this.$URL + '/api/v1/device/' + info_up.id;
				
				this.loading = true;
				if (!info_up.longitude && !info_up.latitude) {
					if (this.location) {

						info_up.longitude = this.location.longitude;
						info_up.latitude  = this.location.latitude;
					}else{
						console.log("No found info location before update");
					}

				}
				
				this.$axios.put(api, info_up).then( res => {
					// console.log(res.data, 'res device')
						this.action_to_field.action = '1';
					Eventbus.$emit('notifications_modal', {
						type: this.$route.name == 'new_device' ? 'saved' : 'updated'
					});
					this.$store.commit("Devices/update", info_up);
					// this.get_list();
					this.loading = false;
					const inf_setting = res.data;
					if (this.$route.name == 'new_device') {						
						localStorage.setItem('settings_device', JSON.stringify({ inf_setting }) );
						Eventbus.$emit('start_installation_progress', info_up);
						this.$router.push('setting_device');
					}else{
						Eventbus.$emit("update_device_to_comp", info_up);
						/*Eventbus.$emit('render_modules',{
							name: 'update_device',
						})
*/					}
				}).catch( er => {
					this.action_to_field.action = '1';
					this.loading = false;
					Eventbus.$emit('notifications_modal', {
						type: 'error'
					});
					console.log(er, 'Error save')
				}) 
			}, // update

			onResize(){
				console.log(this.$refs['card_device' + this.layout_id].$el.clientHeight, 'resize')
				if (this.$refs['card_device' + this.layout_id] && this.$refs['card_device' + this.layout_id].$el) {

					this.height_map = this.$refs['card_device' + this.layout_id].$el.clientHeight - 75;
				}
			}, // onResize

			test_peripheral(item){
					// console.log("TEST new_peripheral 2", item, this.inf)
				if (item && item.route && ((this.action_to_field && this.action_to_field.info) || (this.inf && this.inf.info && this.inf.info.id))) {
					const api 	 =  this.$URL + item.route;
					let info_up  = this.inf && this.inf.info ? { ...this.inf.info }  : { ...this.action_to_field.info}  ;
					this.loading = true;
					this.$axios.post(api, info_up).then(res =>{
						console.log("RES TEST peripheral ", res);
						this.loading = false;
						this.$EventBus.$emit('notifications_modal',{
							type 	: "success",
							message : this.$ml.get('test_peripheral')
						})
					}).catch(er => {
						console.warn("Error test peripheral : ", er);
						this.loading = false;
						
						this.$EventBus.$emit('notifications_modal',{
							type 	: "error",
							message : this.$ml.get('test_peripheral')
						})
					});
				}else{
					console.warn("Required route or id for request");
				}
			}, // test_peripheral
		}, // methods 
		
		mounted(){
			Eventbus.$on("update_device_bus", (action) => {
				if (action) {
					/*this.action_to_field.info 	= action;
					this.inf.info 				= action; */
					this.render_info(action);
				}
			});

			this.$nextTick(()=>{
				
				this.onResize();
			});
		}, // mounted

	}; // export defaul

</script>